import { BulkCreditRequest, BulkUtilResponse, BulkMoveCodeResponse, BulkDeleteCodeTableRows, BulkDiscountRequest, BulkCancelRequest } from "../_types/bulk";
import { IFetchData } from "../_types/post";
import { APIPost } from "./http";

export const MigrateMemberships = async (fromPlan: string, toPlan: string, serviceLocationId: number): Promise<BulkUtilResponse | null> => {
    let postObj = {
        map: {
            [fromPlan]: toPlan
        },
        service_location_id: serviceLocationId
    };

    let request: IFetchData = {
        relay_to: "/util/migratesubscriptions",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<BulkUtilResponse | null>(request);

    return toReturn;
}

//API to move codes from one plan to another
export const MoveCodesAPI = async (fromPlan: string, toPlan: string, amount: number, codeType: string): Promise<BulkMoveCodeResponse | null> => {
    let postObj = {
        FromPlanId: parseInt(fromPlan),
        ToPlanId: parseInt(toPlan),
        NumCodes: amount,
        CodeType: codeType
    };

    let request: IFetchData = {
        relay_to: "/bulk/movecodes",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<BulkMoveCodeResponse | null>(request);
    return toReturn;
}

//this counts codes and sorts by date
export const CountCodesByDateAPI = async (plan: string, codeType: string): Promise<BulkDeleteCodeTableRows[] | null> => {
    let postObj = {
        Plan: parseInt(plan),
        CodeType: codeType
    };

    let request: IFetchData = {
        relay_to: "/bulk/countcodes",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<BulkDeleteCodeTableRows[] | null>(request);
    return toReturn;
}

export const DeleteCodesByDateAPI = async (plan: string, selectedDate: Date | null, codeType: string, userId: number): Promise<number | null> => {
    let postObj = {
        PlanId: parseInt(plan),
        SelectedDate: selectedDate,
        CodeType: codeType,
        UserId: userId

    };

    let request: IFetchData = {
        relay_to: "/bulk/deletecodes",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<number | null>(request);
    return toReturn;
}

export const FreezeMemberships = async (serviceLocationId: number, freezeUntil: Date, planId: string | null): Promise<BulkUtilResponse | null> => {
    const servicePlanId = planId !== null ? Number(planId) : null;

    let postObj = {
        service_location_id: serviceLocationId,
        freeze_until: freezeUntil,
        service_plan_id: servicePlanId
    }
    
    let request: IFetchData = {
        relay_to: "/bulk/holdsubscriptions",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<BulkUtilResponse | null>(request);

    return toReturn;
}

export const UnfreezeMemberships = async (serviceLocationId: number, planId: string | null): Promise<BulkUtilResponse | null> => {
    const servicePlanId = planId !== null ? Number(planId) : null;

    let postObj = {
        service_location_id: serviceLocationId,
        service_plan_id: servicePlanId
    }
    
    let request: IFetchData = {
        relay_to: "/bulk/unholdsubscriptions",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...postObj
    };

    let toReturn = await APIPost<BulkUtilResponse | null>(request);

    return toReturn;
}

export const CreditMemberships = async (creditsRequest: BulkCreditRequest): Promise<BulkUtilResponse | null> => {
      let request: IFetchData = {
          relay_to: "/util/credit_members",
          method: "POST",
          service: "ewapi",
          authorize: true,
          refresh: false,
          ...creditsRequest
      };

      let toReturn = await APIPost<BulkUtilResponse | null>(request);

      return toReturn;
}

export const DiscountMemberships = async (discountRequest: BulkDiscountRequest): Promise<BulkUtilResponse | null> => {
    let request: IFetchData = {
        relay_to: "/bulk/discount_members",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...discountRequest
    };

    let toReturn = await APIPost<BulkUtilResponse | null>(request);

    return toReturn;
}

export const CancelMemberships = async (cancelRequest: BulkCancelRequest): Promise<BulkUtilResponse | null> => {
    let request: IFetchData = {
        relay_to: "/util/cancel_members",
        method: "POST",
        service: "ewapi",
        authorize: true,
        refresh: false,
        ...cancelRequest
    };

    let toReturn = await APIPost<BulkUtilResponse | null>(request);

    return toReturn;
}
